import { SystemEntity } from '@erp/shared-types';
import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';
import { BuildingsIcon } from '@phosphor-icons/react';
import { SystemEntityPreview } from '../preview-ui';
import { useSupplier } from '@/api/rpc/hooks/accounts-payable/useSupplier';

interface SupplierInlineProps {
  entityType: SystemEntity;
  entityId: string;
  className?: string;
}

export function SupplierInline({ entityId, className }: SupplierInlineProps) {
  const { data: supplier, isLoading } = useSupplier(entityId);

  const displayName = isLoading ? 'Loading...' : supplier?.name || 'Supplier';

  return (
    <HoverCard openDelay={200} closeDelay={100}>
      <HoverCardTrigger asChild>
        <div className="inline-block max-w-full">
          <Badge
            variant="outline"
            className={cn('gap-1.5 cursor-pointer max-w-full', className)}
          >
            <BuildingsIcon className="size-3 shrink-0" />
            <span className="truncate">{displayName}</span>
          </Badge>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-auto p-0" align="start">
        <SystemEntityPreview
          entityType={SystemEntity.AP_SUPPLIER}
          entityId={entityId}
        />
      </HoverCardContent>
    </HoverCard>
  );
}
